import { Link } from 'react-router-dom';
import { categories } from '@/mocks/articles';

export default function CategoryGrid() {
  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-3">
            内容分类导航
          </h2>
          <p className="text-sm text-foreground-600 max-w-xl mx-auto">
            八大内容分类，覆盖国产区原创精华，轻松找到您感兴趣的内容领域
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3 md:gap-4">
          {categories.map((cat) => (
            <Link
              key={cat.id}
              to={`/category/${cat.slug}`}
              className="group flex flex-col items-center p-5 md:p-6 rounded-xl bg-background-100 hover:bg-background-200/70 transition-all duration-300 cursor-pointer"
            >
              <div
                className={`w-12 h-12 md:w-14 md:h-14 flex items-center justify-center rounded-xl mb-4 transition-transform duration-300 group-hover:scale-110 ${
                  cat.color === 'accent'
                    ? 'bg-accent-100 text-accent-600'
                    : 'bg-secondary-100 text-secondary-600'
                }`}
              >
                <i className={`${cat.icon} text-xl md:text-2xl`}></i>
              </div>
              <h3 className="text-sm font-medium text-foreground-900 mb-1 whitespace-nowrap">
                {cat.name}
              </h3>
              <p className="text-xs text-foreground-500">{cat.articleCount} 篇文章</p>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}